module.exports = __webpack_public_path__ + "img/create-user.12b244f2.svg";